import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useToast } from "../../utils/toast";
import accountService from "../../services/account/account.service";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const toast = useToast();
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [isFormDisabled, setIsFormDisabled] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isCodeSent && countdown > 0) {
      setIsFormDisabled(true);
      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            setIsFormDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isCodeSent, countdown]);

  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validate: (data) => {
      const errors: any = {};
      if (!data.email) {
        errors.email = "E-posta adresi gereklidir";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
        errors.email = "Geçersiz e-posta adresi";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const response = await accountService.SendPasswordResetEmail(values);
        if (response.result && !response.result.error) {
          setIsCodeSent(true);
          setCountdown(30);
          toast.show("Sıfırlama kodu başarıyla gönderildi", "success");
        } else {
          toast.show(response?.result?.error || "Bir hata oluştu", "error");
        }
      } catch (error) {
        toast.show("Bir hata oluştu", "error");
      }
    }
  });

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <div
          style={{
            borderRadius: "56px",
            padding: "0.3rem",
            background: "linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)"
          }}
        >
          <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: "53px" }}>
            <div className="text-center mb-5">
              <Link to="/">
                <img src="/images/logoosbuk.png" alt="Image" height="50" className="mb-3" />
              </Link>
              <div className="text-900 text-3xl font-medium mb-3">Şifre Sıfırlama</div>
              <span className="text-600 font-medium">Şifrenizi sıfırlamak için e-posta adresinizi giriniz</span>
            </div>

            <form onSubmit={formik.handleSubmit} className="mt-5">
              <div className="flex flex-column gap-3">
                <InputText
                  id="email"
                  name="email"
                  placeholder="E-posta adresiniz"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={`${formik.errors.email ? "p-invalid" : ""} p-2`}
                  disabled={isFormDisabled}
                  style={{ fontSize: "14px" }}
                />
                {formik.errors.email && <small className="p-error">{formik.errors.email}</small>}

                <Button 
                  label={isFormDisabled ? `Tekrar Gönder (${countdown}s)` : "Sıfırlama Kodu Gönder"} 
                  className="w-full p-2 text-base" 
                  type="submit"
                  disabled={isFormDisabled}
                />
              </div>
            </form>

            {isCodeSent && (
              <div className="mt-5 p-3 border-round bg-primary-50">
                <h3 className="text-primary m-0 mb-3">Sıfırlama Kodu Gönderildi!</h3>
                <p className="m-0 line-height-3">E-posta adresinize şifre sıfırlama kodu gönderildi. Lütfen:</p>
                <ul className="mt-2 mb-0 pl-3">
                  <li>Spam/Gereksiz klasörünüzü kontrol etmeyi unutmayın</li>
                  <li>Gelen e-postadaki talimatları takip edin</li>
                  <li>E-posta birkaç dakika içinde ulaşmazsa tekrar deneyebilirsiniz</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
